module.exports = __webpack_public_path__ + "img/notifications_unselected.6a05f29c.svg";